module.exports = __webpack_public_path__ + "img/guide1.e8ac1408.gif";